import { render, staticRenderFns } from "./PromotionHome.vue?vue&type=template&id=4e6ab33c&scoped=true"
import script from "./PromotionHome.vue?vue&type=script&lang=js"
export * from "./PromotionHome.vue?vue&type=script&lang=js"
import style0 from "./PromotionHome.vue?vue&type=style&index=0&id=4e6ab33c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6ab33c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e6ab33c')) {
      api.createRecord('4e6ab33c', component.options)
    } else {
      api.reload('4e6ab33c', component.options)
    }
    module.hot.accept("./PromotionHome.vue?vue&type=template&id=4e6ab33c&scoped=true", function () {
      api.rerender('4e6ab33c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/common/PromotionHome.vue"
export default component.exports